import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'outcomesGroup',
    label: 'Outcomes Group Report',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
